import React, { Component } from 'react';
import _ from 'lodash';

class MultipleChoice extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: []
		};
		this.handleCheck = this.handleCheck.bind(this);
	}
	handleValidation(value) {
		const isEmpty = _.isEqual(value, ['']) || _.isEmpty(value);
		return !isEmpty ? true : false;
	}
	handleParentStateCallback(value) {
		const { id, inputName } = this.props.fieldcollection;
		const validation = this.handleValidation(value);
		const obj = {
			id,
			inputName,
			value,
			validation
		};
		this.props.parentStateCallback(obj);
	}
	handleCheck(e) {
		if (e.target.checked) {
			const addInputValue = [...this.state.value, e.target.value];
			this.setState({
				value: addInputValue
			});
			this.handleParentStateCallback(addInputValue);
		} else if (!e.target.checked) {
			const inputValue = e.target.value;
			const removeInputValue = _.filter(
				this.state.value,
				i => i !== inputValue
			);
			this.setState({
				value: removeInputValue
			});
			this.handleParentStateCallback(removeInputValue);
		}
	}
	builder({ answers, question, id }) {
		return _.map(answers, (answer, i) => {
			const inputId = `${id}_${answer.value}`;
			return (
				<div key={i} className="form-check">
					<input
						type="checkbox"
						value={answer.value}
						id={inputId}
						onChange={this.handleCheck}
						className={
							_.includes(this.props.errors, id)
								? 'form-check-input is-invalid'
								: 'form-check-input'
						}
					/>
					<label htmlFor={inputId} className="form-check-label">
						{answer.label}
					</label>
				</div>
			);
		});
	}
	render() {
		const { question } = this.props.fieldcollection;
		return (
			<div className="border rounded px-4 py-3 mb-4">
				<h5>{question}</h5>
				{_.includes(this.props.errors, this.props.fieldcollection.id) && (
					<div className="alert alert-danger">Selecione al menos un valor.</div>
				)}
				<div>{this.builder(this.props.fieldcollection)}</div>
				<br />
				<div className="d-none">valor: {this.state.value.sort().toString()}</div>
			</div>
		);
	}
}

export default MultipleChoice;



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/FieldCollection/MultipleChoice.js